import axios from "axios";
import { currentCountry } from "@/jurisdictions/country";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const OWNER_ROLES = ["ceo", "associe", "partner"];
export const ADMIN_ROLES = [...OWNER_ROLES, "admin"];
export const ROLE_LABEL = { ceo: "CEO", associe: "Associé", partner: "Associé", admin: "Admin", collaborator: "Collaborateur", client: "Client" };
export const isSuperAdmin = (u) => u?.platform_role === "super_admin";
export const isOwner = (u) => OWNER_ROLES.includes(u?.role);
export const canManageAccounts = (u) => isSuperAdmin(u) || (currentCountry() === "FR" ? u?.role === "admin" : ADMIN_ROLES.includes(u?.role));
export const isCabinetAdmin = (u) => ADMIN_ROLES.includes(u?.role) || isSuperAdmin(u);

api.interceptors.request.use((config) => {
  config.headers["X-Ninyaa-Country"] = currentCountry();
  const token = localStorage.getItem("fidalis_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (config.url === "/auth/login") {
    const device = localStorage.getItem("ninyaa_device_secret");
    if (device) config.headers["X-Device-Secret"] = device;
  }
  return config;
});

api.interceptors.response.use((response) => {
  if (response.data?.device_secret) localStorage.setItem("ninyaa_device_secret", response.data.device_secret);
  return response;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}

export const fmt = (n) =>
  new Intl.NumberFormat("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n || 0);

export const fmtInt = (n) => new Intl.NumberFormat("fr-FR").format(n || 0);

export const blobToBase64 = (blob) =>
  new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onloadend = () => resolve(String(r.result).split(",")[1] || "");
    r.onerror = reject;
    r.readAsDataURL(blob);
  });

export const archiveLivrable = async (input) => {
  const { clientId, module, titre, blob, filename, mime } = input;
  if (!clientId) return { archived: false, reason: "no_client" };
  try {
    const payload = { client_id: clientId, module, titre };
    if (blob) {
      payload.file_b64 = await blobToBase64(blob);
      payload.filename = filename;
      payload.mime = mime || blob.type;
    }
    const { data } = await api.post("/livrables", payload);
    const archived = data.archive_status === "archived";
    if (archived) toast.success(`${titre} : fichier archivé au dossier client.`);
    return { archived, livrable: data };
  } catch (error) {
    toast.error(`Archivage non effectué : ${formatApiError(error)}`, {
      duration: 15000,
      action: { label: "Réessayer", onClick: () => archiveLivrable(input) },
    });
    return { archived: false, error };
  }
};

export const downloadLivrable = async (id, filename) => {
  const res = await api.get(`/livrables/${id}/download`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url; a.download = filename || "livrable"; a.click();
  URL.revokeObjectURL(url);
};
